import React, { Component } from "react";

import { CCard, CCardBody, CCol, CImg, CLink, CRow } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

class CommunityContentRecordings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
      // activity: null,
      // tab: 1,
      // disciplines: [{ name: "Carregando", id: null }],
      // publishLoading: false,
      // start_allocation: "",
      // end_allocation: "",
      // title: ""
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.handleRecordings();
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  handleRecordings() {
    const { id } = this.props.match.params;

    axios
      .post(
        `${URL.api}community/room_recording/list`,
        { room: id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({ recordings: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  correctName(link) {
    return decodeURIComponent(link.split("/").splice(-1)[0]);
  }

  render() {
    const { recordings } = this.state;

    return (
      <>
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <React.Fragment>
            {recordings &&
            recordings.filter(
              recording =>
                recording.link
                  .toLowerCase()
                  .includes(this.props.search.toLowerCase()) ||
                recording.activity_name
                  ?.toLowerCase()
                  .includes(this.props.search.toLowerCase())
            ).length > 0 ? (
              <CRow>
                {recordings
                  .filter(
                    recording =>
                      recording.link
                        .toLowerCase()
                        .includes(this.props.search.toLowerCase()) ||
                      recording.activity_name
                        ?.toLowerCase()
                        .includes(this.props.search.toLowerCase())
                  )
                  .map(recording => (
                    <CCol key={recording.id} xs="6">
                      <CLink
                        className="not-link"
                        href={recording.link}
                        target="_blank"
                      >
                        <CCard className="card-room-activity">
                          <CCardBody className="d-flex align-items-center">
                            {recording.user_name ? (
                              <div
                                className="mr-3"
                                style={{ height: "60px", width: "60px" }}
                              >
                                <CImg
                                  src={
                                    URL.img +
                                    (recording.user_photo ||
                                      "uploads/users/profileEmpty.jpg")
                                  }
                                  style={{
                                    height: "60px",
                                    width: "60px",
                                    borderRadius: "100%"
                                  }}
                                />
                              </div>
                            ) : (
                              <div
                                className="mr-3 d-flex align-items-center justify-content-center"
                                style={{
                                  height: "60px",
                                  width: "60px",
                                  borderRadius: "100%",
                                  backgroundColor: "#3c4b6422"
                                }}
                              >
                                <i
                                  className="fa fa-video-camera"
                                  style={{
                                    color: "#3c4b64",
                                    width: "60px",
                                    textAlign: "center"
                                  }}
                                />
                              </div>
                            )}
                            <div className="d-flex flex-column justify-content-center text-ellipsis">
                              <h5 className="text-overflow mb-1 text-ellipsis">
                                {recording.activity_name
                                  ? `Gravação de ${recording.activity_name}`
                                  : this.correctName(recording.link)}
                              </h5>
                              <div>
                                {recording.user_name
                                  ? `${recording.user_name}`
                                  : recording.room_name}
                              </div>
                              <div>{this.friendlyDate(recording.date)}</div>
                            </div>
                          </CCardBody>
                        </CCard>
                      </CLink>
                    </CCol>
                  ))}
              </CRow>
            ) : (
              <div className="d-flex align-items-center justify-content-center p-3 text-muted">
                Nenhuma gravação encontrada
              </div>
            )}
          </React.Fragment>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentRecordings);
